/* eslint-disable no-undef */
const ACCOUNT_BASE_URL = process.env.REACT_APP_ACCOUNT_BASE_URL
  ? process.env.REACT_APP_ACCOUNT_BASE_URL
  // : 'http://localhost:8000';
  : "https://account.mizbans.com";

const EVENT_BASE_URL = process.env.REACT_APP_EVENT_BASE_URL
  ? process.env.REACT_APP_EVENT_BASE_URL
  // : 'http://localhost:8001';
  : "https://event.mizbans.com";

const TIME_ALGORITHM_BASE_URL = process.env.REACT_APP_TIME_BASE_URL
  ? process.env.REACT_APP_TIME_BASE_URL
  // : 'http://localhost:8002';
  : "https://time.mizbans.com";

const LOCAITON_BASE_URL = process.env.REACT_APP_LOCAITON_BASE_URL
  ? process.env.REACT_APP_LOCAITON_BASE_URL
  // : 'http://localhost:8004';
  : "https://location.mizbans.com";

const ZOOM_BASE_URL = process.env.REACT_APP_ZOOM_BASE_URL
  ? process.env.REACT_APP_ZOOM_BASE_URL
  // : 'http://localhost:3001';
  : "https://zoom.mizbans.com";

const MIZBAN_BASE_URL = process.env.REACT_APP_MIZBAN_BASE_URL
  ? 'mizbans.com'
  : 'localhost:3000';

const GOOGLE_API = process.env.REACT_APP_ACCOUNT_BASE_URL
  ? '444901300844-r4qhltvlok25oagmkk12lto7am93rffh.apps.googleusercontent.com'
  : '444901300844-tmavn56euq1328diqc8cthegjfdop14f.apps.googleusercontent.com';

const urlConfig = {
  ACCOUNT_BASE_URL,
  EVENT_BASE_URL,
  ZOOM_BASE_URL,
  MIZBAN_BASE_URL,
  GOOGLE_API,

  refresh_token_url: ACCOUNT_BASE_URL + '/api/token/refresh/',
  register_url: ACCOUNT_BASE_URL + '/api/register/',
  signIn_url: ACCOUNT_BASE_URL + '/api/login/',
  user_url: ACCOUNT_BASE_URL + '/api/user/',
  get_user_data: ACCOUNT_BASE_URL + '/api/meta/usersinfo',
  meeting_url: EVENT_BASE_URL + '/api/meetings/',
  meeting_landing_url: EVENT_BASE_URL + '/api/meetings/?memory=0',
  meeting_memory_url: EVENT_BASE_URL + '/api/meetings/?memory=1',
  meeting_in_progress_url: EVENT_BASE_URL + '/api/meetings/?memory=2',
  public_meeting: EVENT_BASE_URL + '/api/meetings/?memory=3',
  upload_photo_url: EVENT_BASE_URL + '/api/photos/',

  //meeting info comment
  send_comment_url: EVENT_BASE_URL + '/api/comment/customcreate',
  get_comment_url: EVENT_BASE_URL + '/api/comment/viewcomment/',

  //time algorithm
  time_algorithm_url: TIME_ALGORITHM_BASE_URL + '/api/usertimes/',
  timeTable: TIME_ALGORITHM_BASE_URL + '/api/time/common/',

  //change password in profile
  change_password_url: ACCOUNT_BASE_URL + '/api/password/change/',

  //reset password
  reset_password_url: ACCOUNT_BASE_URL + '/api/password_reset/',
  confirm_password_url: ACCOUNT_BASE_URL + '/api/password_reset/confirm/',

  //login with social app
  login_with_google: ACCOUNT_BASE_URL + '/api/meta/google',
  login_with_facebook: ACCOUNT_BASE_URL + '/api/meta/facebook',

  //connect account
  connect_account: ACCOUNT_BASE_URL + '/api/meta/bindsocial',
  disconnect: ACCOUNT_BASE_URL + '/api/meta/disconnect',
  check_is_connect: ACCOUNT_BASE_URL + '/api/meta/checkconnection',
  check_is_password_exist: ACCOUNT_BASE_URL + '/api/meta/idinfo',

  //twitter
  login_with_twitter: ACCOUNT_BASE_URL + '/api/meta/twitter',
  twitter_token: ACCOUNT_BASE_URL + '/api/meta/twittertoken',
  twitter_access_token: ACCOUNT_BASE_URL + '/api/meta/twitteraccesstoken',

  //Prefer location
  get_places: LOCAITON_BASE_URL + '/api/location/center-location',
  user_prefer_location:
    LOCAITON_BASE_URL + '/api/location/prefer-location-users',
  account_confirm_email: ACCOUNT_BASE_URL + '/account-confirm-email',

  join_zoom: EVENT_BASE_URL + '/api/videocall/zoom',
  subscribe: ACCOUNT_BASE_URL + '/api/meta/subscribe',
};
exports.urlConfig = urlConfig;
